import { Component, OnInit, SecurityContext } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { MeService } from '@client/app/services/entities/me/me.service';
import { UserInterface } from '@monsido/ng2/modules/models/api/interfaces/user.interface';
import { privacy_terms } from '@monsido/core/constants/general.constant';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

declare global {
    interface Window {
        privacy_terms: string;
    }
}

@Component({
    selector: 'privacy-dialog',
    templateUrl: './privacy-dialog.component.html',
    styleUrls: ['./privacy-dialog.component.scss'],
    standalone: false,
})
export class PrivacyDialogComponent implements OnInit {
    modalRef: NgbModalRef | null = null;
    terms = '';
    accept = false;
    saving = false;
    version: string = '';

    constructor (
        private modalService: NgbActiveModal,
        private sanitizer: DomSanitizer,
        private monEventService: MonEventService,
        private meService: MeService,
    ) {}

    ngOnInit (): void {
        this.monEventService.run('actionTrigger', { action: 'accept-terms-dialog-show' });
        this.terms = this.sanitizer.sanitize(SecurityContext.HTML, privacy_terms) ?? '';
    }

    submit (): void {
        if (!this.accept) {
            return;
        }

        this.saving = true;
        this.meService.update({
            privacy_policy_version_accepted: this.version,
        } as Partial<UserInterface>)
            .then(() => {
                this.monEventService.run('actionTrigger', { action: 'accept-terms-dialog-accepted' });
                this.close();
            })
            .catch(() => {
                // Do nothing on error, just reset saving state
            })
            .finally(() => {
                this.saving = false;
            });
    }

    close (): void {
        if (this.modalService) {
            this.modalService.close();
        }
    }
}
